import { I18n } from '@calendly/i18n';
import { FullStoryExclude, FullStoryMask } from '@calendly/ui/components/fullstory-privacy';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { UserInfoAvatar } from 'features/user_profiles';
import { Email, TextWrapper, Title, Wrapper } from './shared';
const roleCss = "r1xfcn1d";
const Role = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'p';
  const as = 'span';
  return <Component ref={ref} {...restProps} as={as} className={classNames(roleCss, props.className)} />;
});
export const MembershipInfo = ({
  membership,
  showUserRole,
  isAvatarNonInteractive = false
}) => <Wrapper>
    <FullStoryExclude>
      <UserInfoAvatar letter={membership.avatar_letter} name={membership.name} src={membership.avatar_url} uuid={membership.user_uuid} isPendingUser={membership?.status === 'pending'} isNonInteractive={isAvatarNonInteractive} />
    </FullStoryExclude>
    <TextWrapper>
      <Title>
        <FullStoryMask>{membership.name}</FullStoryMask>
        {showUserRole && <Role>
              <FullStoryMask>{` (${I18n.t(`publisher.organization.membership_role.${membership.role}`)})`}</FullStoryMask>
            </Role>}
      </Title>
      <Email><FullStoryMask>{membership.email}</FullStoryMask></Email>
    </TextWrapper>
  </Wrapper>;

require("./membership_info.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./membership_info.js");